<template>
  <va-card :title="$t('payments.list.heading')">
    <va-data-table
      :fields="fields"
      :apiMode="true"
      :data="websites"
      :rowClass="rowClass"
      :loading="loading"
      :per-page="20"
      @row-clicked="edit"
    >
      <template slot="allowed_source_sites" slot-scope="props">
        {{ props.rowData.allowed_source_sites.join(' 💰 ') }}
      </template>
    </va-data-table>
    <va-button class="add-button" @click="showLargeModal = true">
      {{ $t('payments.list.addButton') }}</va-button
    >
    <va-modal
      v-model="showLargeModal"
      :noOutsideDismiss="true"
      class="modal"
      size="large"
      @cancel="modalCancel"
      @ok="addWebsiteOrEdit(cacheWebsite)"
    >
      <va-select
        v-model="cacheWebsite.name"
        :placeholder="cacheWebsite.name"
        :options="['stripe','paypal','in_store', 'coinbase']"
      />
      <va-input
        v-model="cacheWebsite.domain_name"
        :placeholder="$t('payments.list.domain_name')"
      />
      <va-select
        :label="$t('forms.selects.searchable')"
        v-model="cacheWebsite.allowed_source_sites"
        searchable
        multiple
        textBy="description"
        class="multiSelect"
        :options="allowedSourceSites"
      />
      <va-input
        v-if="cacheWebsite.name == 'stripe'"
        v-model="cacheWebsite.public_key"
        :placeholder="$t('payments.list.public_key')"
      />
      <va-input
        v-if="cacheWebsite.name == 'stripe'"
        v-model="cacheWebsite.private_key"
        :placeholder="$t('payments.list.private_key')"
      />
      <va-input
        v-if="cacheWebsite.name == 'paypal'"
        v-model="cacheWebsite.email"
        :placeholder="$t('payments.list.email')"
      />
      <va-input
        v-model="cacheWebsite.min_price_to_use"
        :placeholder="$t('payments.list.min_price_to_use')"
      />
      <va-input
        v-model="cacheWebsite.max_price_to_use"
        :placeholder="$t('payments.list.max_price_to_use')"
      />
      <va-input
        v-model="cacheWebsite.max_daily_amount"
        :placeholder="$t('payments.list.max_daily_amount')"
      />
      <va-color-picker-input mode="advanced" v-model="cacheWebsite.color">
        <va-color-square :value="cacheWebsite.color" />
      </va-color-picker-input>
      <va-toggle
        class="is_enabled"
        v-model="cacheWebsite.is_enabled"
        @input="is_enabled"
        small
      />
      <va-button
        class="is_enabled"
        v-if="!cacheWebsite.is_enabled"
        flat
        small
        @click="remove(cacheWebsite.id)"
      >
        {{ $t('tables.delete') }}
      </va-button>
    </va-modal>
  </va-card>
</template>

<script>
export default {
  data () {
    return {
      showLargeModal: false,
      cacheWebsite: {
        name: '',
        domain_name: '',
        payment_url: '',
        min_price_to_use: '',
        max_price_to_use: '',
        max_daily_amount: '',
        allowed_source_sites: [],
        is_enabled: true,
        color: '#000',
      },
    }
  },
  computed: {
    loading () {
      return this.websites.length < 1
    },
    websites () {
      return this.$store.getters.PaymentsMethods
    },
    allowedSourceSites () {
      return this.$store.getters.allowedSourceSitesList
    },
    fields () {
      return [
        {
          name: 'name',
          title: this.$t('payments.list.name'),
        },
        {
          name: '__slot:allowed_source_sites',
          title: this.$t('payments.list.allowed_source_sites'),
        },
        {
          name: 'domain_name',
          title: this.$t('payments.list.domain_name'),
        },
        {
          name: 'min_price_to_use',
          title: this.$t('payments.list.min_price_to_use'),
        },
        {
          name: 'max_price_to_use',
          title: this.$t('payments.list.max_price_to_use'),
        },
        {
          name: 'max_daily_amount',
          title: this.$t('payments.list.max_daily_amount'),
        },
      ]
    },
  },
  methods: {
    is_enabled () {
      if (!this.cacheWebsite.id) {
        this.cacheWebsite.is_enabled = true
      }
    },
    modalCancel () {
      this.showLargeModal = false
      for (const key in this.cacheWebsite) {
        this.cacheWebsite[key] = ''
      }
      this.cacheWebsite.allowed_source_sites = []
      this.cacheWebsite.is_enabled = true
    },
    addWebsiteOrEdit (PaymentMethod) {
      PaymentMethod = Object.assign({}, PaymentMethod)
      if (PaymentMethod.id) {
        this.$store.dispatch('updatePaymentMethod', PaymentMethod)
      } else {
        this.$store.dispatch('addPaymentMethod', PaymentMethod)
      }
      this.cacheWebsiteClear()
    },
    rowClass (website, index) {
      return website.is_enabled ? 'work' : 'not-work'
    },
    edit (website) {
      for (const key in website) {
        if (Object.hasOwnProperty.call(website, key)) {
          this.cacheWebsite[key] = website[key]
        }
      }
      this.showLargeModal = !this.showLargeModal
    },
    async remove (id) {
      if (id) {
        this.$store.dispatch('deletePaymentMethod', id)
      }
      this.cacheWebsiteClear()
    },
    cacheWebsiteClear () {
      for (const key in this.cacheWebsite) {
        if (Object.hasOwnProperty.call(this.cacheWebsite, key)) {
          this.cacheWebsite[key] = ''
        }
      }
      this.cacheWebsite.is_enabled = true
      this.cacheWebsite.allowed_source_sites = []
    },
  },
  created () {
    this.$store.dispatch('getPaymentsMethods')
  },
}
</script>

<style lang="scss">
.not-work {
  td {
    color: $dropdown-background;
    background-color: $theme-danger !important;
  }
}

.multiSelect {
  span {
    color: black;
  }
}

tr {
  cursor: pointer;
}

.is_enabled {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.va-modal__inner {
  min-width: 500px;
}

.add-button {
  display: block;
  margin-left: auto !important;
}
</style>
